<!-- header -->
<ng-content select="app-modal-header"></ng-content>

<!-- content -->
<ng-content select="app-modal-content"></ng-content>

<!-- actions -->
<ng-content select="app-modal-actions"></ng-content>
